export default __webpack_public_path__ + "static/media/txt.81fe2bac.svg";